import { default as _91_46_46_46identifier_93ILmkVIqRlAMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/[...identifier].vue?macro=true";
import { default as indexj2SfCX51S4Meta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/about-us/index.vue?macro=true";
import { default as _91addressId_93KL43ZlTKmZMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/address-book/[addressId].vue?macro=true";
import { default as indexVw4duE1IKlMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/address-book/index.vue?macro=true";
import { default as all_45productseF3IOokIVZMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/all-products.vue?macro=true";
import { default as _91id_936kEdKQw5ocMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/blogs/[id].vue?macro=true";
import { default as indexK5l979gA3TMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/blogs/index.vue?macro=true";
import { default as _91handle_93Op3mqQAMBgMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/brands/[handle].vue?macro=true";
import { default as index0tasgYG3zLMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/brands/index.vue?macro=true";
import { default as indexuwHvj75nCXMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/index.vue?macro=true";
import { default as indexYrh1LG2RtLMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/onboarding/index.vue?macro=true";
import { default as signupfLHBuHul5IMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/onboarding/signup.vue?macro=true";
import { default as verifytSz1aSPFFnMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/verify.vue?macro=true";
import { default as indexnAsiUiFT3DMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/cart/index.vue?macro=true";
import { default as indexQqvmtk2xAeMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout-invalid/index.vue?macro=true";
import { default as indexRal1KXgUYIMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout-thankyou/index.vue?macro=true";
import { default as indexAoJBqwiBfHMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout-verify/index.vue?macro=true";
import { default as _91chash_931FxiGpQM7xMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout/[chash].vue?macro=true";
import { default as _91handle_93Y17XQuldXdMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/collections/[handle].vue?macro=true";
import { default as indexwOfKzuy5tIMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/collections/index.vue?macro=true";
import { default as _91handle_93wCDLhtkdN7Meta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/drops/[handle].vue?macro=true";
import { default as index2oo7vx7zDuMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/drops/index.vue?macro=true";
import { default as index3p7NccV6MrMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/help-center/index.vue?macro=true";
import { default as indexzRXVuxD928Meta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/help-center/policies/index.vue?macro=true";
import { default as indexAD5fXVfxQmMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/login/index.vue?macro=true";
import { default as new_45arrivals7gicQwKVdNMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/new-arrivals.vue?macro=true";
import { default as _91handle_938w0DqspSOhMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/nodes/[handle].vue?macro=true";
import { default as indexJm7TXxrTPOMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/onboarding/index.vue?macro=true";
import { default as _91orderNumber_93W08OtfFxLtMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/orders/[orderNumber].vue?macro=true";
import { default as indexgdXfBWQmBgMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/orders/index.vue?macro=true";
import { default as _91orderNumber_93kLiH1PuT9eMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/orders/return-items/[orderNumber].vue?macro=true";
import { default as _91page_identifier_93hHwgSS6A4OMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/policy-pages/[page_identifier].vue?macro=true";
import { default as previewv9SUFi9Rm1Meta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/preview.vue?macro=true";
import { default as index8WJNNf95aYMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/privacy-policy/index.vue?macro=true";
import { default as _91handle_93RwqUcVpVtdMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/products/[handle].vue?macro=true";
import { default as indexeD6ZVy0wqHMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/profile/index.vue?macro=true";
import { default as indexlRIx7UAoJLMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/refund-policy/index.vue?macro=true";
import { default as indexNWzbKRAqMEMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/return-policy/index.vue?macro=true";
import { default as indexNK1WZS8z9OMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/rewards-faq/index.vue?macro=true";
import { default as indexwP4qAZfUHRMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/rewards-history/index.vue?macro=true";
import { default as indexjL04gpKwQxMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/rewards/index.vue?macro=true";
import { default as indexbLCHVsYz0nMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/search/index.vue?macro=true";
import { default as _91handle_93LGQisWvDeMMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/set/[handle].vue?macro=true";
import { default as indexq7iHgzAKlSMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/shipping-delivery/index.vue?macro=true";
import { default as static_45previewuIM2NPnT32Meta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/static-preview.vue?macro=true";
import { default as _91slug_93QuyWRuVB5BMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/styling-videos/[slug].vue?macro=true";
import { default as indexOYYTQro6CUMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/styling-videos/index.vue?macro=true";
import { default as indexvJF3tRtKNLMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/terms-conditions/index.vue?macro=true";
import { default as _91handle_93EdalGo72IZMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/wishlist/[handle].vue?macro=true";
import { default as notify_45meW8xRgMhHrGMeta } from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/wishlist/notify-me.vue?macro=true";
export default [
  {
    name: _91_46_46_46identifier_93ILmkVIqRlAMeta?.name ?? "identifier",
    path: _91_46_46_46identifier_93ILmkVIqRlAMeta?.path ?? "/:identifier(.*)*",
    meta: _91_46_46_46identifier_93ILmkVIqRlAMeta || {},
    alias: _91_46_46_46identifier_93ILmkVIqRlAMeta?.alias || [],
    redirect: _91_46_46_46identifier_93ILmkVIqRlAMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/[...identifier].vue").then(m => m.default || m)
  },
  {
    name: indexj2SfCX51S4Meta?.name ?? "about-us",
    path: indexj2SfCX51S4Meta?.path ?? "/about-us",
    meta: indexj2SfCX51S4Meta || {},
    alias: indexj2SfCX51S4Meta?.alias || [],
    redirect: indexj2SfCX51S4Meta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: _91addressId_93KL43ZlTKmZMeta?.name ?? "address-book-addressId",
    path: _91addressId_93KL43ZlTKmZMeta?.path ?? "/address-book/:addressId()",
    meta: _91addressId_93KL43ZlTKmZMeta || {},
    alias: _91addressId_93KL43ZlTKmZMeta?.alias || [],
    redirect: _91addressId_93KL43ZlTKmZMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/address-book/[addressId].vue").then(m => m.default || m)
  },
  {
    name: indexVw4duE1IKlMeta?.name ?? "address-book",
    path: indexVw4duE1IKlMeta?.path ?? "/address-book",
    meta: indexVw4duE1IKlMeta || {},
    alias: indexVw4duE1IKlMeta?.alias || [],
    redirect: indexVw4duE1IKlMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/address-book/index.vue").then(m => m.default || m)
  },
  {
    name: all_45productseF3IOokIVZMeta?.name ?? "all-products",
    path: all_45productseF3IOokIVZMeta?.path ?? "/all-products",
    meta: all_45productseF3IOokIVZMeta || {},
    alias: all_45productseF3IOokIVZMeta?.alias || [],
    redirect: all_45productseF3IOokIVZMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/all-products.vue").then(m => m.default || m)
  },
  {
    name: _91id_936kEdKQw5ocMeta?.name ?? "blogs-id",
    path: _91id_936kEdKQw5ocMeta?.path ?? "/blogs/:id()",
    meta: _91id_936kEdKQw5ocMeta || {},
    alias: _91id_936kEdKQw5ocMeta?.alias || [],
    redirect: _91id_936kEdKQw5ocMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/blogs/[id].vue").then(m => m.default || m)
  },
  {
    name: indexK5l979gA3TMeta?.name ?? "blogs",
    path: indexK5l979gA3TMeta?.path ?? "/blogs",
    meta: indexK5l979gA3TMeta || {},
    alias: indexK5l979gA3TMeta?.alias || [],
    redirect: indexK5l979gA3TMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/blogs/index.vue").then(m => m.default || m)
  },
  {
    name: _91handle_93Op3mqQAMBgMeta?.name ?? "brands-handle",
    path: _91handle_93Op3mqQAMBgMeta?.path ?? "/brands/:handle()",
    meta: _91handle_93Op3mqQAMBgMeta || {},
    alias: _91handle_93Op3mqQAMBgMeta?.alias || [],
    redirect: _91handle_93Op3mqQAMBgMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/brands/[handle].vue").then(m => m.default || m)
  },
  {
    name: index0tasgYG3zLMeta?.name ?? "brands",
    path: index0tasgYG3zLMeta?.path ?? "/brands",
    meta: index0tasgYG3zLMeta || {},
    alias: index0tasgYG3zLMeta?.alias || [],
    redirect: index0tasgYG3zLMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/brands/index.vue").then(m => m.default || m)
  },
  {
    name: indexuwHvj75nCXMeta?.name ?? "campus-program",
    path: indexuwHvj75nCXMeta?.path ?? "/campus-program",
    meta: indexuwHvj75nCXMeta || {},
    alias: indexuwHvj75nCXMeta?.alias || [],
    redirect: indexuwHvj75nCXMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/index.vue").then(m => m.default || m)
  },
  {
    name: indexYrh1LG2RtLMeta?.name ?? "campus-program-onboarding",
    path: indexYrh1LG2RtLMeta?.path ?? "/campus-program/onboarding",
    meta: indexYrh1LG2RtLMeta || {},
    alias: indexYrh1LG2RtLMeta?.alias || [],
    redirect: indexYrh1LG2RtLMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/onboarding/index.vue").then(m => m.default || m)
  },
  {
    name: signupfLHBuHul5IMeta?.name ?? "campus-program-onboarding-signup",
    path: signupfLHBuHul5IMeta?.path ?? "/campus-program/onboarding/signup",
    meta: signupfLHBuHul5IMeta || {},
    alias: signupfLHBuHul5IMeta?.alias || [],
    redirect: signupfLHBuHul5IMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/onboarding/signup.vue").then(m => m.default || m)
  },
  {
    name: verifytSz1aSPFFnMeta?.name ?? "campus-program-verify",
    path: verifytSz1aSPFFnMeta?.path ?? "/campus-program/verify",
    meta: verifytSz1aSPFFnMeta || {},
    alias: verifytSz1aSPFFnMeta?.alias || [],
    redirect: verifytSz1aSPFFnMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/campus-program/verify.vue").then(m => m.default || m)
  },
  {
    name: indexnAsiUiFT3DMeta?.name ?? "cart",
    path: indexnAsiUiFT3DMeta?.path ?? "/cart",
    meta: indexnAsiUiFT3DMeta || {},
    alias: indexnAsiUiFT3DMeta?.alias || [],
    redirect: indexnAsiUiFT3DMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: indexQqvmtk2xAeMeta?.name ?? "checkout-invalid",
    path: indexQqvmtk2xAeMeta?.path ?? "/checkout-invalid",
    meta: indexQqvmtk2xAeMeta || {},
    alias: indexQqvmtk2xAeMeta?.alias || [],
    redirect: indexQqvmtk2xAeMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout-invalid/index.vue").then(m => m.default || m)
  },
  {
    name: indexRal1KXgUYIMeta?.name ?? "checkout-thankyou",
    path: indexRal1KXgUYIMeta?.path ?? "/checkout-thankyou",
    meta: indexRal1KXgUYIMeta || {},
    alias: indexRal1KXgUYIMeta?.alias || [],
    redirect: indexRal1KXgUYIMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout-thankyou/index.vue").then(m => m.default || m)
  },
  {
    name: indexAoJBqwiBfHMeta?.name ?? "checkout-verify",
    path: indexAoJBqwiBfHMeta?.path ?? "/checkout-verify",
    meta: indexAoJBqwiBfHMeta || {},
    alias: indexAoJBqwiBfHMeta?.alias || [],
    redirect: indexAoJBqwiBfHMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout-verify/index.vue").then(m => m.default || m)
  },
  {
    name: _91chash_931FxiGpQM7xMeta?.name ?? "checkout-chash",
    path: _91chash_931FxiGpQM7xMeta?.path ?? "/checkout/:chash()",
    meta: _91chash_931FxiGpQM7xMeta || {},
    alias: _91chash_931FxiGpQM7xMeta?.alias || [],
    redirect: _91chash_931FxiGpQM7xMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/checkout/[chash].vue").then(m => m.default || m)
  },
  {
    name: _91handle_93Y17XQuldXdMeta?.name ?? "collections-handle",
    path: _91handle_93Y17XQuldXdMeta?.path ?? "/collections/:handle()",
    meta: _91handle_93Y17XQuldXdMeta || {},
    alias: _91handle_93Y17XQuldXdMeta?.alias || [],
    redirect: _91handle_93Y17XQuldXdMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/collections/[handle].vue").then(m => m.default || m)
  },
  {
    name: indexwOfKzuy5tIMeta?.name ?? "collections",
    path: indexwOfKzuy5tIMeta?.path ?? "/collections",
    meta: indexwOfKzuy5tIMeta || {},
    alias: indexwOfKzuy5tIMeta?.alias || [],
    redirect: indexwOfKzuy5tIMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/collections/index.vue").then(m => m.default || m)
  },
  {
    name: _91handle_93wCDLhtkdN7Meta?.name ?? "drops-handle",
    path: _91handle_93wCDLhtkdN7Meta?.path ?? "/drops/:handle()",
    meta: _91handle_93wCDLhtkdN7Meta || {},
    alias: _91handle_93wCDLhtkdN7Meta?.alias || [],
    redirect: _91handle_93wCDLhtkdN7Meta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/drops/[handle].vue").then(m => m.default || m)
  },
  {
    name: index2oo7vx7zDuMeta?.name ?? "drops",
    path: index2oo7vx7zDuMeta?.path ?? "/drops",
    meta: index2oo7vx7zDuMeta || {},
    alias: index2oo7vx7zDuMeta?.alias || [],
    redirect: index2oo7vx7zDuMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/drops/index.vue").then(m => m.default || m)
  },
  {
    name: index3p7NccV6MrMeta?.name ?? "help-center",
    path: index3p7NccV6MrMeta?.path ?? "/help-center",
    meta: index3p7NccV6MrMeta || {},
    alias: index3p7NccV6MrMeta?.alias || [],
    redirect: index3p7NccV6MrMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/help-center/index.vue").then(m => m.default || m)
  },
  {
    name: indexzRXVuxD928Meta?.name ?? "help-center-policies",
    path: indexzRXVuxD928Meta?.path ?? "/help-center/policies",
    meta: indexzRXVuxD928Meta || {},
    alias: indexzRXVuxD928Meta?.alias || [],
    redirect: indexzRXVuxD928Meta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/help-center/policies/index.vue").then(m => m.default || m)
  },
  {
    name: indexAD5fXVfxQmMeta?.name ?? "login",
    path: indexAD5fXVfxQmMeta?.path ?? "/login",
    meta: indexAD5fXVfxQmMeta || {},
    alias: indexAD5fXVfxQmMeta?.alias || [],
    redirect: indexAD5fXVfxQmMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: new_45arrivals7gicQwKVdNMeta?.name ?? "new-arrivals",
    path: new_45arrivals7gicQwKVdNMeta?.path ?? "/new-arrivals",
    meta: new_45arrivals7gicQwKVdNMeta || {},
    alias: new_45arrivals7gicQwKVdNMeta?.alias || [],
    redirect: new_45arrivals7gicQwKVdNMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/new-arrivals.vue").then(m => m.default || m)
  },
  {
    name: _91handle_938w0DqspSOhMeta?.name ?? "nodes-handle",
    path: _91handle_938w0DqspSOhMeta?.path ?? "/nodes/:handle()",
    meta: _91handle_938w0DqspSOhMeta || {},
    alias: _91handle_938w0DqspSOhMeta?.alias || [],
    redirect: _91handle_938w0DqspSOhMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/nodes/[handle].vue").then(m => m.default || m)
  },
  {
    name: indexJm7TXxrTPOMeta?.name ?? "onboarding",
    path: indexJm7TXxrTPOMeta?.path ?? "/onboarding",
    meta: indexJm7TXxrTPOMeta || {},
    alias: indexJm7TXxrTPOMeta?.alias || [],
    redirect: indexJm7TXxrTPOMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/onboarding/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93W08OtfFxLtMeta?.name ?? "orders-orderNumber",
    path: _91orderNumber_93W08OtfFxLtMeta?.path ?? "/orders/:orderNumber()",
    meta: _91orderNumber_93W08OtfFxLtMeta || {},
    alias: _91orderNumber_93W08OtfFxLtMeta?.alias || [],
    redirect: _91orderNumber_93W08OtfFxLtMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexgdXfBWQmBgMeta?.name ?? "orders",
    path: indexgdXfBWQmBgMeta?.path ?? "/orders",
    meta: indexgdXfBWQmBgMeta || {},
    alias: indexgdXfBWQmBgMeta?.alias || [],
    redirect: indexgdXfBWQmBgMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93kLiH1PuT9eMeta?.name ?? "orders-return-items-orderNumber",
    path: _91orderNumber_93kLiH1PuT9eMeta?.path ?? "/orders/return-items/:orderNumber()",
    meta: _91orderNumber_93kLiH1PuT9eMeta || {},
    alias: _91orderNumber_93kLiH1PuT9eMeta?.alias || [],
    redirect: _91orderNumber_93kLiH1PuT9eMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/orders/return-items/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91page_identifier_93hHwgSS6A4OMeta?.name ?? "policy-pages-page_identifier",
    path: _91page_identifier_93hHwgSS6A4OMeta?.path ?? "/policy-pages/:page_identifier()",
    meta: _91page_identifier_93hHwgSS6A4OMeta || {},
    alias: _91page_identifier_93hHwgSS6A4OMeta?.alias || [],
    redirect: _91page_identifier_93hHwgSS6A4OMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/policy-pages/[page_identifier].vue").then(m => m.default || m)
  },
  {
    name: previewv9SUFi9Rm1Meta?.name ?? "preview",
    path: previewv9SUFi9Rm1Meta?.path ?? "/preview",
    meta: previewv9SUFi9Rm1Meta || {},
    alias: previewv9SUFi9Rm1Meta?.alias || [],
    redirect: previewv9SUFi9Rm1Meta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/preview.vue").then(m => m.default || m)
  },
  {
    name: index8WJNNf95aYMeta?.name ?? "privacy-policy",
    path: index8WJNNf95aYMeta?.path ?? "/privacy-policy",
    meta: index8WJNNf95aYMeta || {},
    alias: index8WJNNf95aYMeta?.alias || [],
    redirect: index8WJNNf95aYMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: _91handle_93RwqUcVpVtdMeta?.name ?? "products-handle",
    path: _91handle_93RwqUcVpVtdMeta?.path ?? "/products/:handle()",
    meta: _91handle_93RwqUcVpVtdMeta || {},
    alias: _91handle_93RwqUcVpVtdMeta?.alias || [],
    redirect: _91handle_93RwqUcVpVtdMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/products/[handle].vue").then(m => m.default || m)
  },
  {
    name: indexeD6ZVy0wqHMeta?.name ?? "profile",
    path: indexeD6ZVy0wqHMeta?.path ?? "/profile",
    meta: indexeD6ZVy0wqHMeta || {},
    alias: indexeD6ZVy0wqHMeta?.alias || [],
    redirect: indexeD6ZVy0wqHMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexlRIx7UAoJLMeta?.name ?? "refund-policy",
    path: indexlRIx7UAoJLMeta?.path ?? "/refund-policy",
    meta: indexlRIx7UAoJLMeta || {},
    alias: indexlRIx7UAoJLMeta?.alias || [],
    redirect: indexlRIx7UAoJLMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/refund-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexNWzbKRAqMEMeta?.name ?? "return-policy",
    path: indexNWzbKRAqMEMeta?.path ?? "/return-policy",
    meta: indexNWzbKRAqMEMeta || {},
    alias: indexNWzbKRAqMEMeta?.alias || [],
    redirect: indexNWzbKRAqMEMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/return-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexNK1WZS8z9OMeta?.name ?? "rewards-faq",
    path: indexNK1WZS8z9OMeta?.path ?? "/rewards-faq",
    meta: indexNK1WZS8z9OMeta || {},
    alias: indexNK1WZS8z9OMeta?.alias || [],
    redirect: indexNK1WZS8z9OMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/rewards-faq/index.vue").then(m => m.default || m)
  },
  {
    name: indexwP4qAZfUHRMeta?.name ?? "rewards-history",
    path: indexwP4qAZfUHRMeta?.path ?? "/rewards-history",
    meta: indexwP4qAZfUHRMeta || {},
    alias: indexwP4qAZfUHRMeta?.alias || [],
    redirect: indexwP4qAZfUHRMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/rewards-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexjL04gpKwQxMeta?.name ?? "rewards",
    path: indexjL04gpKwQxMeta?.path ?? "/rewards",
    meta: indexjL04gpKwQxMeta || {},
    alias: indexjL04gpKwQxMeta?.alias || [],
    redirect: indexjL04gpKwQxMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: indexbLCHVsYz0nMeta?.name ?? "search",
    path: indexbLCHVsYz0nMeta?.path ?? "/search",
    meta: indexbLCHVsYz0nMeta || {},
    alias: indexbLCHVsYz0nMeta?.alias || [],
    redirect: indexbLCHVsYz0nMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: _91handle_93LGQisWvDeMMeta?.name ?? "set-handle",
    path: _91handle_93LGQisWvDeMMeta?.path ?? "/set/:handle()",
    meta: _91handle_93LGQisWvDeMMeta || {},
    alias: _91handle_93LGQisWvDeMMeta?.alias || [],
    redirect: _91handle_93LGQisWvDeMMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/set/[handle].vue").then(m => m.default || m)
  },
  {
    name: indexq7iHgzAKlSMeta?.name ?? "shipping-delivery",
    path: indexq7iHgzAKlSMeta?.path ?? "/shipping-delivery",
    meta: indexq7iHgzAKlSMeta || {},
    alias: indexq7iHgzAKlSMeta?.alias || [],
    redirect: indexq7iHgzAKlSMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/shipping-delivery/index.vue").then(m => m.default || m)
  },
  {
    name: static_45previewuIM2NPnT32Meta?.name ?? "static-preview",
    path: static_45previewuIM2NPnT32Meta?.path ?? "/static-preview",
    meta: static_45previewuIM2NPnT32Meta || {},
    alias: static_45previewuIM2NPnT32Meta?.alias || [],
    redirect: static_45previewuIM2NPnT32Meta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/static-preview.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93QuyWRuVB5BMeta?.name ?? "styling-videos-slug",
    path: _91slug_93QuyWRuVB5BMeta?.path ?? "/styling-videos/:slug()",
    meta: _91slug_93QuyWRuVB5BMeta || {},
    alias: _91slug_93QuyWRuVB5BMeta?.alias || [],
    redirect: _91slug_93QuyWRuVB5BMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/styling-videos/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexOYYTQro6CUMeta?.name ?? "styling-videos",
    path: indexOYYTQro6CUMeta?.path ?? "/styling-videos",
    meta: indexOYYTQro6CUMeta || {},
    alias: indexOYYTQro6CUMeta?.alias || [],
    redirect: indexOYYTQro6CUMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/styling-videos/index.vue").then(m => m.default || m)
  },
  {
    name: indexvJF3tRtKNLMeta?.name ?? "terms-conditions",
    path: indexvJF3tRtKNLMeta?.path ?? "/terms-conditions",
    meta: indexvJF3tRtKNLMeta || {},
    alias: indexvJF3tRtKNLMeta?.alias || [],
    redirect: indexvJF3tRtKNLMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/terms-conditions/index.vue").then(m => m.default || m)
  },
  {
    name: _91handle_93EdalGo72IZMeta?.name ?? "wishlist-handle",
    path: _91handle_93EdalGo72IZMeta?.path ?? "/wishlist/:handle()",
    meta: _91handle_93EdalGo72IZMeta || {},
    alias: _91handle_93EdalGo72IZMeta?.alias || [],
    redirect: _91handle_93EdalGo72IZMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/wishlist/[handle].vue").then(m => m.default || m)
  },
  {
    name: notify_45meW8xRgMhHrGMeta?.name ?? "wishlist-notify-me",
    path: notify_45meW8xRgMhHrGMeta?.path ?? "/wishlist/notify-me",
    meta: notify_45meW8xRgMhHrGMeta || {},
    alias: notify_45meW8xRgMhHrGMeta?.alias || [],
    redirect: notify_45meW8xRgMhHrGMeta?.redirect,
    component: () => import("/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/pages/wishlist/notify-me.vue").then(m => m.default || m)
  }
]